import { redirect } from "react-router";
import { supabase } from "../supabase";

export type UserRole = "admin" | "broker" | "coordinador" | "asesor" | "marketing";

export async function requireAuth() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw redirect("/login");
  return user;
}

export async function requireAdmin() {
  const user = await requireAuth();
  if (user.app_metadata?.role !== "admin") throw redirect("/");
  return user;
}

export async function requireRole(...roles: UserRole[]) {
  const user = await requireAuth();
  const role = (user.app_metadata?.role ?? "asesor") as UserRole;
  if (!roles.includes(role)) throw redirect("/");
  return user;
}

export function getUserRole(user: { app_metadata?: Record<string, unknown> } | null): UserRole {
  return ((user?.app_metadata?.role as UserRole) ?? "asesor");
}

export function hasRole(user: { app_metadata?: Record<string, unknown> } | null, ...roles: UserRole[]): boolean {
  return roles.includes(getUserRole(user));
}
